import MundialRequestTask from "./MundialRequestTask";

export class LineupTask extends MundialRequestTask {
  matchId: string;

  constructor(matchId: string) {
    super();
    this.matchId = matchId;
  }

  getUrl() {
    const baseUrl = this.getBaseUrl();
    return `${baseUrl}/matches/${this.matchId}/lineups`;
  }

  getParams() {
    const params = super.getParams();
    return {
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/LineupTask.ts